const elvSearchWordGroups = [["color","colour"],["colors","colours"],["colored","coloured"],["colorful","colourful"],["personalized","personalised"],["personalization","personalisation"],["personalize","personalise"],["customized","customised"],["customization","customisation"],["customize","customise"],["flavor","flavour"],["flavors","flavours"],["flavored","flavoured"],["favorite","favourite"],["favorites","favourites"],["jewelry","jewellery"],["center","centre"],["centers","centres"],["gray","grey"],["savory","savoury"],["cozy","cosy"],["yogurt","yoghurt"],["donut","doughnut"],["donuts","doughnuts"],["mom","mum"],["moms","mums"],["mommy","mummy"],["bouquet","boquet","bouqet"],["bouquets","boquets","bouqets"],["anniversary","anniversery","aniversary"],["chocolate","choclate"],["chocolates","choclates"]];
const elvSearchWordVariants = new Map();
for (const group of elvSearchWordGroups) {
  for (const word of group) elvSearchWordVariants.set(word, group);
}
const elvSearchPhrases = ["red velvet","black forest","white forest","ferrero rocher","birthday cake","anniversary cake","wedding cake","photo cake","chocolate cake","fruit cake","ice cream","gift hamper","gift hampers","gift basket","gift baskets","gift box","gift boxes","greeting card","greeting cards","birthday card","birthday cards","soft toy","soft toys","teddy bear","teddy bears","personalized gift","personalized gifts","personalised gift","personalised gifts","custom gift","custom gifts","dry fruit","dry fruits","dairy free","gluten free","sugar free"];
const elvSearchPhrasePattern = new RegExp('\\b(?:' + [...elvSearchPhrases]
  .sort((a, b) => b.length - a.length)
  .map(phrase => phrase.split(' ').join('[\\s-]*'))
  .join('|') + ')\\b', 'gi');
const elvSearchPhraseNames = new Map(elvSearchPhrases.map(phrase => [phrase.replace(/\s+/g, ''), phrase]));
function elvNormalizeGiftText(text, canonicalSpellings = false) {
  return String(text).normalize('NFKC')
    .replace(/[’‘]/g, "'")
    .replace(elvSearchPhrasePattern, phrase => elvSearchPhraseNames.get(phrase.toLowerCase().replace(/[\s-]+/g, '')))
    .replace(/\begg[\s-]+less\b/gi, 'eggless')
    .replace(/[a-z]+/gi, word => canonicalSpellings ? (elvSearchWordVariants.get(word.toLowerCase())?.[0] || word) : word)
    .replace(/\s+/g, ' ').trim();
}
function elvGiftSearchQuery(text, vendor) {
  const quote = value => JSON.stringify(value);
  const tokens = elvNormalizeGiftText(text).split(/\s+/).filter(Boolean);
  const clauses = tokens.map(word => {
    const variants = elvSearchWordVariants.get(word.toLowerCase()) || [word];
    return '(' + variants.flatMap(value => [
      quote(value), 'tag:' + quote(value), 'product_type:' + quote(value)
    ]).join(' OR ') + ')';
  });
  return clauses.join(' AND ') + ' AND vendor:' + quote(vendor);
}
function elvGiftSuggestionKey(text) {
  return elvNormalizeGiftText(text, true).toLowerCase().replace(/[\s-]+/g, '');
}
const elvRankingRequests = new Map();
async function elvCollectionRanks(path) {
  if (elvRankingRequests.has(path)) return elvRankingRequests.get(path);
  const task = (async () => {
    const key = 'elvNativeRanksV2:' + path;
    try {
      const cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && Date.now() - cached.time < 300000) return cached.ids;
    } catch {}
    const page = async number => {
      const url = new URL(path, location.origin);
      url.searchParams.set('sort_by', 'best-selling'); url.searchParams.set('view', 'search-ranking'); url.searchParams.set('page', number);
      const response = await fetch(url, {credentials: 'same-origin'});
      if (!response.ok) throw new Error('Collection unavailable');
      return response.json();
    };
    const first = await page(1);
    const rest = await Promise.all(Array.from({length: Math.max(0, first.pages - 1)}, (_, i) => page(i + 2)));
    const ids = [first, ...rest].flatMap(data => data.ids);
    try { sessionStorage.setItem(key, JSON.stringify({time: Date.now(), ids})); } catch {}
    return ids;
  })();
  elvRankingRequests.set(path, task);
  task.catch(() => elvRankingRequests.delete(path));
  return task;
}
(async function initSearch(searchParams) {
  const form = document.querySelector('[data-elv-gift-search]');
  if (!form || form.dataset.initialized) return;
  form.dataset.initialized = 'true';
  const country = form.querySelector('[data-elv-country]');
  const keyword = form.querySelector('[data-elv-keyword]');
  const query = form.querySelector('[data-elv-query]');
  const params = searchParams || new URLSearchParams(location.search);
  const cleanCountry = params.get('country');
  const nativeCategories = JSON.parse(document.querySelector('[data-elv-native-categories]')?.textContent || '{}');
  const aliases = {cake:'cakes',cakes:'cakes',flower:'flowers',flowers:'flowers',chocolate:'chocolates',chocolates:'chocolates',hamper:'gift-hampers',hampers:'gift-hampers','gift hamper':'gift-hampers','gift hampers':'gift-hampers','personalized gift':'personalized-gifts','personalized gifts':'personalized-gifts','soft toy':'soft-toys','soft toys':'soft-toys'};
  const nativeSearchURL = (text, destination, sortValue = 'best-selling') => {
    const path = nativeCategories[destination]?.[aliases[elvNormalizeGiftText(text, true).toLowerCase()]];
    if (!path) return null;
    const url = new URL(path, location.origin);
    url.searchParams.set('view', 'country-search'); url.searchParams.set('sort_by', sortValue === 'relevance' ? 'best-selling' : sortValue);
    url.searchParams.set('gift_query', text); return url;
  };

  if (!searchParams && cleanCountry && params.get('q') && !params.get('q').includes(' AND vendor:')) {
    const option = Array.from(country.options).find(o => o.dataset.country === cleanCountry);
    if (option) {
      const originalTyped = params.get('q').slice(0, 200);
      const typed = elvNormalizeGiftText(originalTyped);
      const native = nativeSearchURL(typed, cleanCountry, params.get('sort') || 'best-selling');
      if (native) { location.replace(native); return; }
      const internal = new URLSearchParams({q: elvGiftSearchQuery(typed, option.value), gift_query:originalTyped, type:'product', view:'country', 'options[prefix]':'last'});
      if (params.get('sort')) { internal.set('sort', params.get('sort')); internal.set('sort_by', params.get('sort') === 'best-selling' ? 'relevance' : params.get('sort')); }
      const url = new URL(form.action); url.search = internal.toString();
      try {
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Search unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = doc.querySelector('[data-elv-results]');
        if (!section) throw new Error('Search unavailable');
        document.querySelector('[data-elv-results]').replaceWith(document.importNode(section, true));
        form.dataset.initialized = ''; return initSearch(internal);
      } catch { form.dataset.initialized = ''; location.replace(url); return; }
    }
  }
  const raw = params.get('q') || '';
  const results = document.querySelector('[data-elv-results]');
  const chosenSort = params.get('sort') || (params.get('gift_sort') === 'best-selling' ? 'best-selling' : params.get('sort_by')) || 'best-selling';
  const bestSelling = chosenSort === 'best-selling';
  const requestURL = new URL(form.action); requestURL.search = params.toString(); requestURL.searchParams.delete('country'); requestURL.searchParams.delete('sort'); requestURL.searchParams.set('sort_by', bestSelling ? 'relevance' : chosenSort);
  const vendorMatch = raw.match(/ AND vendor:"([^"]+)"$/);
  let saved = '';
  try { saved = localStorage.getItem('elvDestinationCountry') || (localStorage.getItem('elvSearchCountry') || '').replace(/^Expressluv /, '').toLowerCase(); } catch {}
  const options = Array.from(country.options);
  const selected = options.find(o => vendorMatch ? o.value === vendorMatch[1] : o.dataset.country === form.dataset.country)
    || options.find(o => o.dataset.country === saved);
  if (selected) country.value = selected.value;
  if (params.get('gift_query')) keyword.value = params.get('gift_query');
  if (vendorMatch) {
    const text = raw.slice(0, vendorMatch.index);
    keyword.value = params.get('gift_query') || Array.from(text.matchAll(/(?:^| AND )\(?"((?:\\.|[^"\\])*)"/g), m => m[1].replace(/\\(.)/g, '$1')).join(' ');
  }
  const help = document.querySelector('#elv-search-help');
  const original = form.querySelector('[data-elv-original]');
  const setDestination = (value, broadcast = true) => {
    const option = options.find(o => o.dataset.country === value);
    if (!value) {
      country.value = ''; help.hidden = true;
      try { localStorage.removeItem('elvDestinationCountry'); localStorage.removeItem('elvSearchCountry'); } catch {}
      if (broadcast) document.dispatchEvent(new CustomEvent('elv:destination', {detail: {country: '', source: 'search'}}));
      return;
    }
    if (!option) return;
    country.value = option.value;
    country.setCustomValidity('');
    help.hidden = true;
    try { localStorage.setItem('elvDestinationCountry', value); localStorage.removeItem('elvSearchCountry'); } catch {}
    if (broadcast) document.dispatchEvent(new CustomEvent('elv:destination', {detail: {country: value, source: 'search'}}));
    const base = (form.dataset.collectionsRoot || '/collections') + '/' + value;
    if (!results?.hasAttribute('data-elv-native-collection') && nativeCategories[value] && Object.keys(nativeCategories[value]).length) elvCollectionRanks(base).catch(() => {});
  };
  if (country.value) setDestination(country.selectedOptions[0].dataset.country);
  document.addEventListener('elv:destination', e => setDestination(e.detail.country, false));
  document.querySelector('#lp-country')?.addEventListener('change', e => setDestination(e.target.value.toLowerCase().replace('united states', 'usa')));
  const viewport = window.matchMedia('(max-width: 767px)');
  const setPlaceholder = () => keyword.placeholder = viewport.matches ? keyword.dataset.mobilePlaceholder : keyword.dataset.desktopPlaceholder;
  setPlaceholder(); viewport.addEventListener('change', setPlaceholder);
  let prompted = false;
  const requestCountry = () => {
    help.hidden = false; help.textContent = country.dataset.requiredMessage;
    country.focus();
    try { country.showPicker(); } catch {}
    prompted = true;
  };
  const suggestions = document.querySelector('#elv-gift-suggestions');
  const terms = (suggestions?.dataset.terms || '').split('|');
  let activeSuggestion = -1;
  const closeSuggestions = () => {
    suggestions.hidden = true;
    keyword.setAttribute('aria-expanded', 'false');
    keyword.removeAttribute('aria-activedescendant');
    activeSuggestion = -1;
  };
  const chooseSuggestion = value => { keyword.value = value; closeSuggestions(); keyword.focus(); };
  keyword.addEventListener('input', () => {
    suggestions.replaceChildren();
    activeSuggestion = -1;
    if (!country.value && keyword.value.trim()) { closeSuggestions(); if (!prompted) requestCountry(); return; }
    const prefix = elvGiftSuggestionKey(keyword.value);
    const matches = prefix ? terms.filter(t => elvGiftSuggestionKey(t).startsWith(prefix)).slice(0, 6) : [];
    matches.forEach((term, index) => {
      const button = document.createElement('button');
      button.type = 'button'; button.role = 'option'; button.id = 'elv-suggestion-' + index;
      button.textContent = term; button.setAttribute('aria-selected', 'false');
      button.addEventListener('click', () => chooseSuggestion(term));
      suggestions.append(button);
    });
    suggestions.hidden = !matches.length;
    keyword.setAttribute('aria-expanded', String(!!matches.length));
  });
  keyword.addEventListener('keydown', event => {
    if (suggestions.hidden) return;
    const buttons = Array.from(suggestions.children);
    if (event.key === 'Escape') { closeSuggestions(); return; }
    if (event.key === 'Enter' && activeSuggestion >= 0) { event.preventDefault(); chooseSuggestion(buttons[activeSuggestion].textContent); return; }
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    event.preventDefault();
    activeSuggestion = (activeSuggestion + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
    buttons.forEach((b, i) => b.setAttribute('aria-selected', String(i === activeSuggestion)));
    keyword.setAttribute('aria-activedescendant', buttons[activeSuggestion].id);
  });
  document.addEventListener('click', e => { if (!e.target.closest('.elv-search-wrap')) closeSuggestions(); });
  const sort = document.querySelector('[data-elv-sort]');
  if (sort) {
    for (const name of ['gift_query', 'corrected']) {
      if (!params.has(name)) continue;
      const field = document.createElement('input'); field.type = 'hidden'; field.name = name; field.value = params.get(name); sort.form.append(field);
    }
    const bestOption = sort.querySelector('[value="best-selling"]');
    if (bestOption && results?.dataset.rankUrl) bestOption.disabled = false;
    if (bestSelling && bestOption && !bestOption.disabled) sort.value = 'best-selling';
    sort.value = chosenSort;
    sort.addEventListener('change', () => {
      if (results?.hasAttribute('data-elv-native-collection')) { const next = new URL(location.href); next.searchParams.set('sort_by',sort.value); next.searchParams.delete('page'); location.href = next; return; }
      const native = nativeSearchURL(params.get('gift_query') || keyword.value, country.selectedOptions[0].dataset.country, sort.value);
      if (native) { location.href = native; return; }
      const next = new URL(form.action);
      next.searchParams.set('view','country'); next.searchParams.set('country',country.selectedOptions[0].dataset.country);
      next.searchParams.set('q',params.get('gift_query') || keyword.value);
      next.searchParams.set('sort',sort.value); location.href = next;
    });
  }
  if (vendorMatch) {
    const clean = new URL(form.action); clean.searchParams.set('view','country');
    clean.searchParams.set('country',country.selectedOptions[0].dataset.country);
    clean.searchParams.set('q',params.get('corrected') || params.get('gift_query') || keyword.value);
    if (chosenSort !== 'best-selling') clean.searchParams.set('sort',chosenSort);
    history.replaceState(null, '', clean);
  }
  const quote = value => '"' + value.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
  country.addEventListener('change', () => {
    prompted = false;
    setDestination(country.value ? country.selectedOptions[0].dataset.country : '');
  });
  const dictionary = [...new Set((terms.join(' ') + ' ' + elvSearchWordGroups.flat().join(' ') + ' cake flower chocolate eggless vegan birthday anniversary personalized hamper').toLowerCase().match(/[a-z]+/g))];
  const oneEdit = (a, b) => {
    if (Math.abs(a.length - b.length) > 1) return false;
    if (a.length === b.length) {
      const changed = [...a].map((c, i) => c === b[i] ? -1 : i).filter(i => i >= 0);
      return changed.length === 1 || (changed.length === 2 && changed[1] === changed[0] + 1 && a[changed[0]] === b[changed[1]] && a[changed[1]] === b[changed[0]]);
    }
    const shorter = a.length < b.length ? a : b;
    const longer = a.length < b.length ? b : a;
    for (let i = 0; i < longer.length; i++) if (longer.slice(0, i) + longer.slice(i + 1) === shorter) return true;
    return false;
  };
  const correctTypos = text => elvNormalizeGiftText(text).replace(/[a-z]+/gi, word => {
    const lower = word.toLowerCase();
    if (lower.length < 3 || dictionary.includes(lower)) return word;
    const matches = dictionary.filter(term => oneEdit(lower, term));
    return matches.length === 1 ? matches[0] : word;
  });
  const correction = document.querySelector('[data-elv-correction]');
  const corrected = params.get('corrected');
  if (correction && corrected && params.get('gift_query') && corrected !== params.get('gift_query')) {
    correction.hidden = false;
    correction.textContent = correction.dataset.label + ' “' + corrected + '” ' + correction.dataset.instead + ' “' + params.get('gift_query') + '”.';
  }
  const displayTerm = (params.get('corrected') || params.get('gift_query') || keyword.value).slice(0, 200);
  const resultsLabel = document.querySelector('[data-elv-results-label]');
  if (resultsLabel) {
    const mobileResults = window.matchMedia('(max-width: 767px)');
    const updateResultsLabel = () => {
      const count = resultsLabel.textContent.match(/^\s*(\d+)/);
      const label = mobileResults.matches && resultsLabel.dataset.mobileTemplate ? resultsLabel.dataset.mobileTemplate : resultsLabel.dataset.template;
      resultsLabel.textContent = label.replace('__TERM__', displayTerm).replace(/^\d+/, count ? count[1] : results.dataset.count);
    };
    updateResultsLabel();
    mobileResults.addEventListener('change', updateResultsLabel);
  }
  const emptyHeading = document.querySelector('[data-elv-no-matches]');
  document.querySelectorAll('[data-elv-no-matches]').forEach(heading => { heading.textContent = heading.dataset.template.replace('__TERM__', (params.get('gift_query') || keyword.value).slice(0, 200)); });
  const didMean = document.querySelector('[data-elv-did-mean]');
  const proposed = correctTypos(params.get('gift_query') || keyword.value);
  if (didMean && proposed !== (params.get('gift_query') || keyword.value)) {
    didMean.hidden = false;
    const link = didMean.querySelector('a');
    link.textContent = proposed;
    const target = new URL(location.href);
    target.searchParams.set('q', elvGiftSearchQuery(proposed, country.value));
    target.searchParams.set('gift_query', proposed); target.searchParams.set('corrected', proposed); target.searchParams.delete('page'); target.searchParams.delete('gift_page');
    link.href = target;
  }
  document.querySelectorAll('[data-elv-whatsapp]').forEach(whatsapp => {
    const contact = new URL(whatsapp.href);
    contact.searchParams.set('text', 'Hi Expressluv, I’m looking for "' + (params.get('gift_query') || keyword.value).slice(0, 200) + '" to send to ' + (results?.dataset.country || '') + '. Can you help?');
    whatsapp.href = contact;
  });
  const mic = form.querySelector('[data-elv-mic]');
  const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (mic && Recognition) {
    mic.hidden = false;
    const recognition = new Recognition();
    recognition.lang = document.documentElement.lang || 'en-US';
    recognition.continuous = false; recognition.interimResults = false;
    mic.addEventListener('click', () => {
      if (mic.getAttribute('aria-pressed') === 'true') { recognition.stop(); return; }
      try { recognition.start(); } catch { help.hidden = false; help.textContent = mic.dataset.error; }
    });
    recognition.onstart = () => { mic.setAttribute('aria-pressed', 'true'); help.hidden = false; help.textContent = mic.dataset.listening; };
    recognition.onresult = event => {
      keyword.value = event.results[0][0].transcript.slice(0, 200);
      help.hidden = true;
      if (!country.value) requestCountry(); else keyword.focus();
    };
    recognition.onerror = () => { help.hidden = false; help.textContent = mic.dataset.error; };
    recognition.onend = () => { mic.setAttribute('aria-pressed', 'false'); if (help.textContent === mic.dataset.listening) help.hidden = true; };
  }
  form.addEventListener('submit', event => {
    const text = keyword.value.trim();
    if (!country.value || !text) {
      event.preventDefault();
      if (!country.value) requestCountry();
      else if (!text) { keyword.value = ''; keyword.reportValidity(); keyword.focus(); }
      return;
    }
    event.preventDefault();
    const correctedText = correctTypos(text);
    const native = nativeSearchURL(correctedText, country.selectedOptions[0].dataset.country);
    if (native) { native.searchParams.set('gift_query',text); setDestination(country.selectedOptions[0].dataset.country); location.href = native; return; }
    const next = new URL(form.action);
    next.searchParams.set('q', elvGiftSearchQuery(correctedText, country.value));
    next.searchParams.set('gift_query',text); next.searchParams.set('corrected',correctedText);
    next.searchParams.set('type','product'); next.searchParams.set('view','country'); next.searchParams.set('options[prefix]','last');
    setDestination(country.selectedOptions[0].dataset.country); location.href = next;
  });
  const grid = document.querySelector('[data-elv-matches]');
  const consolidateCards = () => {
    if (!grid) return;
    const groups = new Map();
    for (const card of Array.from(grid.querySelectorAll('.elv-search-card'))) {
      const key = card.dataset.vendor + '|' + card.dataset.title;
      const first = groups.get(key);
      if (!first) { groups.set(key, card); continue; }
      card.remove();
    }
    if (sort?.value === 'price-ascending' || sort?.value === 'price-descending') {
      const direction = sort.value === 'price-ascending' ? 1 : -1;
      const ordered = Array.from(grid.querySelectorAll('.elv-search-card')).sort((a, b) => direction * (Number(a.dataset.price) - Number(b.dataset.price)));
      ordered.forEach(card => grid.append(card));
    }
  };
  const pagination = document.querySelector('[data-elv-pagination]');
  const status = document.querySelector('.elv-search-load-status');
  if (grid && pagination && results?.hasAttribute('data-elv-native-collection')) {
    const showing = document.querySelector('[data-elv-showing]');
    const button = document.querySelector('[data-elv-load-more]');
    let nextPage = pagination.dataset.next;
    const update = () => {
      consolidateCards();
      showing.textContent = showing.dataset.template.replace('__SHOWN__',String(grid.children.length)).replace('__TOTAL__',results.dataset.count);
      button.hidden = !nextPage;
    };
    pagination.hidden = true; update();
    button.addEventListener('click', async () => {
      button.disabled = true;
      try {
        const url = new URL(nextPage, location.origin);
        url.searchParams.set('view','country-search'); url.searchParams.set('sort_by',chosenSort);
        url.searchParams.set('gift_query',params.get('gift_query') || keyword.value);
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Results unavailable');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const ids = new Set(Array.from(grid.children).map(card => card.dataset.productId));
        doc.querySelectorAll('[data-elv-matches] .elv-search-card').forEach(card => { if (!ids.has(card.dataset.productId)) grid.append(document.importNode(card,true)); });
        nextPage = doc.querySelector('[data-elv-pagination]')?.dataset.next || '';
        status.hidden = true; update();
      } catch { status.hidden = false; status.textContent = status.dataset.failed; }
      button.disabled = false;
    });
  } else if (grid && pagination) {
    const totalPages = Number(pagination.dataset.pages);
    const showing = document.querySelector('[data-elv-showing]');
    const button = document.querySelector('[data-elv-load-more]');
    const cards = new Map(Array.from(grid.children).map(card => [card.dataset.productId, card]));
    const read = async (url, json = false) => {
      const response = await fetch(url, {credentials:'same-origin'});
      if (!response.ok) throw new Error('Search unavailable');
      return json ? response.json() : new DOMParser().parseFromString(await response.text(), 'text/html');
    };
    const nativeURL = (page, view) => { const url = new URL(requestURL); url.searchParams.set('page',page); url.searchParams.set('view',view); return url; };
    const batches = async (values, fn) => { const output=[]; for(let i=0;i<values.length;i+=4) output.push(...await Promise.all(values.slice(i,i+4).map(fn))); return output; };
    let ordered = [], shown = 0;
    const cardPages = new Set([Number(pagination.dataset.page)]);
    const appendNext = async () => {
      button.disabled = true;
      try {
        const targetSize = grid.children.length + (shown ? 40 : 0);
        if (!shown) grid.replaceChildren();
        const desired = shown ? targetSize : 40;
        while (grid.children.length < desired && shown < ordered.length) {
          const next = ordered.slice(shown,shown + desired - grid.children.length);
          const pages = [...new Set(next.filter(item=>!cards.has(String(item.id))).map(item=>item.page))];
          await batches(pages, async page => {
            const doc = await read(nativeURL(page,'search-cards'));
            doc.querySelectorAll('.elv-search-card').forEach(card=>cards.set(card.dataset.productId,card)); cardPages.add(page);
          });
          next.forEach(item => { const card=cards.get(String(item.id)); if(card) grid.append(document.importNode(card,true)); });
          shown += next.length; consolidateCards();
        }
        if (shown >= ordered.length) ordered.length = grid.children.length;
        showing.textContent = showing.dataset.template.replace('__SHOWN__', String(grid.children.length)).replace('__TOTAL__', String(ordered.length));
        button.hidden = shown >= ordered.length; status.hidden = true; results.removeAttribute('data-elv-pending');
      } catch { results.removeAttribute('data-elv-pending'); status.hidden=false; status.textContent=status.dataset.failed; }
      button.disabled=false;
    };
    button.addEventListener('click',appendNext);
    pagination.hidden = true; button.hidden = true;
    status.hidden=false; status.textContent=bestSelling ? results.dataset.bestLoading : status.dataset.loading;
    try {
      const rankTask = bestSelling && results.dataset.rankUrl ? elvCollectionRanks(results.dataset.rankUrl) : Promise.resolve([]);
      const firstData = await read(nativeURL(1,'search-data'),true);
      const restData = await batches(Array.from({length:Math.max(0,firstData.pages-1)},(_,i)=>i+2),page=>read(nativeURL(page,'search-data'),true));
      ordered = [firstData,...restData].flatMap(data=>data.items);
      const rankIds = await rankTask;
      if (rankIds.length) {
        const ranks = new Map(rankIds.map((id,i)=>[String(id),i]));
        ordered.sort((a,b)=>(ranks.get(String(a.id))??Infinity)-(ranks.get(String(b.id))??Infinity));
      }
      const titles=new Set(), ids=new Set(); ordered=ordered.filter(item=>{if(titles.has(item.title) || ids.has(String(item.id)))return false;titles.add(item.title);ids.add(String(item.id));return true;});
      if (resultsLabel) resultsLabel.textContent = resultsLabel.textContent.replace(/^\d+/, String(ordered.length));
      await appendNext();
    } catch { results.removeAttribute('data-elv-pending'); pagination.hidden=false; status.hidden=false; status.textContent=bestSelling ? results.dataset.bestFailed : status.dataset.failed; }
  } else { consolidateCards(); results?.removeAttribute('data-elv-pending'); }
})();

